<template>
  <b-card align="left">
    <template v-slot:header>
    </template>
    <b-container>
      <b-row>
        <b-col lg="2" style="margin-bottom: 20px">
          <b-button @click="backByOneRecord" variant="outline-primary">
            <b-icon icon="chevron-left" variant="success"></b-icon>
            Назад
          </b-button>
        </b-col>
        <b-col lg="10"></b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
          <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col lg="4">
          Страница: {{ currentPage }}
        </b-col>
        <b-col lg="4">
          <b-form-select
              v-model="perPage"
              :options="options">
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
      <b-table
          striped
          hover
          sticky-header="900px"
          :items="items"
          :fields="fields">
        <template v-slot:cell(QuestionnaireId)="row">
          <b-button @click="openAnswer(row.item.QuestionnaireId)" variant="link">Подробнее</b-button>
        </template>
        <template v-slot:cell(Start)="data">
          {{ toTimeZone(data.item.Start) }}
        </template>
        <template v-slot:cell(LastAnswer)="data">
          {{ toTimeZone(data.item.LastAnswer) }}
        </template>
      </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4">
          <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col lg="4">
          Страница: {{ currentPage }}
        </b-col>
        <b-col lg="4">
          <b-form-select
              v-model="perPage"
              :options="options">
          </b-form-select>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:footer>
      <b-container  class="text-right">
        <small>© Customer Service 2020</small>
      </b-container>
    </template>
  </b-card>
</template>

<script>
import RestApi from '../store/RestApi'
import moment from 'moment'

export default {
  name: 'StatisticsPage',
  data () {
    return {
      options: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 75, text: '75' },
        { value: 100, text: '100' }
      ],
      perPage: 25,
      currentPage: 1,
      fields: [
        { key: 'ClientName', label: 'Клиент', sortable: true },
        { key: 'CountAnswer', label: 'Количество ответов', sortable: false },
        { key: 'Start', label: 'Начата', sortable: true },
        { key: 'LastAnswer', label: 'Последний ответ', sortable: true },
        { key: 'QuestionnaireId', label: ' ', sortable: true }
      ],
      items: []
    }
  },
  mounted () {
    const api = new RestApi();
    if (this.$route.params.token === api.tokenAuth) {
      this.downloadsData()
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  },
  methods: {
    toTimeZone (time) {
      // const zone = moment.tz.guess()
      const format = 'YYYY/MM/DD HH:mm'
      return moment(time, format).add(2, 'hours').format(format)
    },
    downloadsData () {
      const schemaId = this.$route.params.schemaId
      if (schemaId === 0) {
        return
      }
      RestApi.QuestionnaireStatBySchema(schemaId).then((responce) => {
        this.items = responce.data
      }).catch((error) => {
        console.log(error)
      })
    },
    backByOneRecord () {
      console.log('forwardByOneRecord')
      this.$router.go(-1)
    },
    openAnswer (id) {
      this.$router.push({path: `/admin/open_answer/${id}/${this.$route.params.token}`})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatisticsPage.vue